<!-- 日销售报表 -->
<template>
    <div id="home">
    	<van-nav-bar
		  	:title="$t('DayReport.title')"
			left-arrow
			fixed
		  	:right-text="$t('DayReport.export')"
		  	@click-right="onClickExport"
		  	@click-left="$router.go(-1)">
		</van-nav-bar>

		<van-cell>
			<van-row>
		  		<van-col span="24" class="tc">{{$t('DayReport.dateTime')}}{{year}}-{{month}}-{{day}}</van-col>
		  		<div class='totalPrice'>{{$t('payMethod.totalprice')}}{{total}}</div>
			</van-row>
		</van-cell>
		<!-- <van-cell center :value="$t('DayReport.dateTime')+year+'-'+month+'-'+day" value-class="tc"></van-cell> -->
		<van-cell-group v-if="dayData.length>0">
			<van-cell>
				<van-row>
			  		<van-col span="6">{{$t('DayReport.ticket')}}</van-col>
			  		<van-col span="6">{{$t('DayReport.num')}}</van-col>
			  		<van-col span="3">{{$t('DayReport.peoopleNum')}}</van-col>
			  		<van-col span="5">{{$t('payMethod.method')}}</van-col>
			  		<van-col span="4">{{$t('DayReport.price')}}</van-col>
				</van-row>
				<div slot="right-icon" style="width: 22px;"></div>
			</van-cell>
			<template v-for="(item,index) in dayData">
				<van-cell is-link :to="{ path: '/OrderDetail/'+item.id}">
					<!-- OrderDetail -->
					<van-row>
				  		<van-col span="6">{{item.ticket}}</van-col>
				  		<van-col span="6">{{item.place_name}}</van-col>
				  		<van-col span="3">{{item.sitter}}{{$t('DayReport.people')}}</van-col>
				  		<van-col span="5">{{item.method}}</van-col>
				  		<van-col span="4">{{item.final_price}}</van-col>
					</van-row>
				</van-cell>
			</template>
		</van-cell-group>
		<h4 v-else style="text-align: center;">{{$t('DayReport.none')}}</h4>
    </div>
</template>
<script>
  	export default {
  		data () {
	      	return {
	      		total:'',
	      		dayData:[],
	      		year:new Date().getFullYear(),
				month:new Date().getMonth()+1,
				day:new Date().getDate()
	      	}
	    },
	    mounted:function(){
	    	this.getDayData();
	    },
	    methods:{
	    	// 获取当天报表
	    	getDayData(){
	    		if(this.$route.query.year){
    				this.year=this.$route.query.year;
                	this.month=this.$route.query.month;
                	this.day=this.$route.query.day;
	    		}
				this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/eachDayIncome',
	                data:{
	                	year:this.year,
	                	month:this.month,
	                	day:this.day,
	                },
	            }).then(res => {
	            	console.log(res)
	            	if(res.data.status==200){
	            		var dayList = [];
	            		res.data.data.forEach((item,index) => {
	            			// 1：现金，2：微信，3：支付宝，4：Apple Pay，5：信用卡，6：其他，7：paypal，8：my pay，9：line pay
	            			if(item.payment_method==1){
	            				item.method = this.$t('payMethod.cash');
	            			}else if(item.payment_method==5){
	            				item.method = this.$t('payMethod.card');
	            			}else if(item.payment_method==9){
	            				item.method = 'Line Pay';
	            			}else{
	            				item.method = this.$t('payMethod.other');
	            			}
	            			dayList.push(item);
	            		})
	                	this.dayData=dayList;
	                	this.total=res.data.total;
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	
	            });
	    	},
	    	// 导出报表
			onClickExport(){
				window.location.href = this.$build+'/api/store/'+sessionStorage.actShopId+'/exportReport?param=eachDayIncome&year='+this.year+'&month='+this.month+'&day='+this.day;
			}
	  	}
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-cell__left-icon, .van-cell__right-icon{
		font-size: 22px;
	}
	/deep/ .van-nav-bar__right .van-nav-bar__text{color: #fff;}
	.chartBox{
		width: 100%;
		min-height: 240px;
		background-color: #fff;
	}
	.content{
		color: #000;
	}
	.tc{
		text-align: center;
	}
	.totalPrice{
		position: absolute;
		right:0px;
		top:0;
	}
</style>


// WEBPACK FOOTER //
// src/Report/DayReport.vue